
<div class="dasboard-width" >
  <div class="row header mar-lft-rgt-0">

    <div class="col-md-4 col-sm-4">{{displayData.pageName}}</div>
    <div class="col-md-4 col-sm-4">
      <button class="btn btn-success addButton" (click)="openModal(content)">{{displayData.openModalButton}}</button>
    </div>
<!--    <div class="col-md-4 col-sm-4">-->
<!--      <ol class="breadcrumb cust-bread">-->
<!--        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i-->
<!--          class="fa fa-dashboard"></i> Home</a></li>-->
<!--        <li class="breadcrumb-item active" aria-current="page">{{displayData.breadcrumb}}</li>-->
<!--      </ol>-->
<!--    </div>-->
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="col-md-3 col-sm-3">
      <div class="views-title">
        Views
      </div>
      <div class="views-body">
        Folders
        <button class="btn btn-light" (click)="toggleViews()"><i class="fa " [ngClass]="displayed?'fa-minus':'fa-plus'"></i></button>
      </div>
        <!-- <div class="views" [hidden]="!displayed" (click)="getTableData()"> -->
        <div class="views" [hidden]="!displayed">
          <!--<i class="fa fa-inbox"></i>-->
          <!--{{displayData.folderName}}-->
          <!--<span class="badge badge-primary pull-right">{{totalData}}</span>-->
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected"
                  (change)="getTableData()">
            <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
          </select>
      </div>
    </div>
    <div class="col-md-9 col-sm-9">
        <div class="card">
            <div class="card-header card-header-top">
              {{displayData.tabName}}
              <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected items:<span>{{selected}}</span>)
              </div>
              <div class="pull-right font-13">
                <select class="custom-select mr-sm-2 radius-0 font-13 custom-width" [(ngModel)]="pageSizeSelected" (change)="onPageSizeChange($event.target.selectedIndex)">
                  <option *ngFor="let pageSize of pageSizeObj" [value]="pageSize.id">{{pageSize.value}}</option>
                </select>
                <button class="btn btn-primary addButton" [disabled]="previousOffset === 0" (click)="getPreviousData()"> < </button>&nbsp;
                <button class="btn btn-danger addButton" [disabled]="nextOffset === 0"(click)="getNextData()"> > </button>&nbsp;
                <span><b>Page</b> {{page_no}} <b>Of</b> {{totalPage}} &nbsp;&nbsp;<b>Total items: </b> {{totalData}}</span>
                <!--<b>Total items: </b> <span>{{totalData}}</span>-->
              </div>
            </div>
            <div class="card-body card-body-grid">
                <angular-slickgrid gridId='asset-value-grid'
                (onAngularGridCreated)="angularGridReady($event)"
                [columnDefinitions]="columnDefinitions"
                [gridOptions]="gridOptions"
                [dataset]="dataset"
                [gridWidth]="2000"
                >
                </angular-slickgrid>
    
            </div>
          </div>

      <!-- <div class="card">
        <div class="card-header card-header-top">
          {{displayData.tabName}}
          <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected items:<span>{{selected}}</span>)
          </div>
          <div class="pull-right font-13">
            <b>Total items: </b> <span>{{totalData}}</span>
          </div>
        </div>
        <div class="card-body card-body-grid">
          <angular-slickgrid gridId='common-grid'
                             (onAngularGridCreated)="angularGridReady($event)"
                             [columnDefinitions]="columnDefinitions"
                             [gridOptions]="gridOptions"
                             [dataset]="dataset"
                             [gridWidth]="2000"
          >
          </angular-slickgrid>

        </div>
      </div> -->

    </div>
<!--    <div class="offset-sm-9 col-sm-3 mar-top-9">-->
<!--      <button class="btn btn-primary addButton" [disabled]="prevPath === undefined" (click)="changeRouting(prevPath)"><< Prev</button>&nbsp;-->
<!--      <button class="btn btn-danger addButton" [disabled]="nextPath === undefined"(click)="changeRouting(nextPath)">Next >></button>-->
<!--    </div>-->
  </div>
</div>

<!--<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"></app-base-template>-->
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle1">
    <div class="modal-title">Add Digital Asset Value</div>
  </div>
  <div class="modal-body assetValueModalBody">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <mat-tab-group mat-align-tabs="center">
      <mat-tab label="Add manually">
        <div class="form-group mar-top-9">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected"
                  (change)="onMasterChange($event.target.selectedIndex)">
            <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
          </select>
        </div>
        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="descriptionSelected"
                  (change)="onDescriptionChange($event.target.selectedIndex)">
            <option *ngFor="let desc of descObj" [value]="desc.descId">{{desc.description}}</option>
          </select>
        </div>

        <div *ngFor="let column of columnNameObj" class="form-group columnAddFormField">
          <label class="columnAddLabel">{{column.columnName}}</label>

          <select *ngIf="column.validationValue;else input_content" class="custom-select radius-0 font-13 asset-select" [(ngModel)]="assetValueObj[column.columnId]">
            <option [value]="" [selected]="true" [disabled]="true">Select {{column.columnName}}</option>
            <option *ngFor="let validation of column.validationValue" [value]="validation">{{validation}}</option>
          </select>

          <ng-template #input_content>
            <input *ngIf="column.columnName === 'Asset ID';else input_value_content" type="text" [readonly]="true" class="form-control radius-0 font-13" [(ngModel)]="assetValueObj[column.columnId]" placeholder="{{column.columnName}}">
            <ng-template #input_value_content>
              <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValueObj[column.columnId]" placeholder="{{column.columnName}}">
            </ng-template>
          </ng-template>
        </div>
        <button  type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
      </mat-tab>
      <mat-tab #tab label="Bulk upload" *ngIf="!isModifyAsset">
        <div class="row mar-lft-rgt-0">
          <div class="col-sm-6 pad-15 text-center">
            <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                     (complete)="onFileComplete($event)" [formData]="formData"></app-material-fileupload>
          </div>
          <div class="col-sm-6 pad-15 text-center">
            <button [disabled]="templatebtndisabled" type="button" class="btn btn-primary radius-0" (click)="downloadAssetTemplate()">Generate Template</button>
            <div class="pad-5 text-center" [innerHTML]="templateDownloadMessage"></div>
          </div>
        </div>
		<div class="row mar-lft-rgt-0">
          <div class="col-sm-6 pad-15 text-center" [innerHTML]="uploadSuccessMessage"></div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="modal-footer pad-8">
<!--    <button  type="button" class="btn btn-success radius-0" (click)="save()">Save</button>-->
    <button type="button" class="btn btn-danger radius-0" (click)="close();getTableData();">Cancel</button>
  </div>
</ng-template>
<!--==================================================================================================-->
<notifier-container></notifier-container>
